export class TableDataSource{
    constructor() {
        this.container= [];
        this.columns= []
        this.action= "config"
        this.edit= {}
    }
}

export default TableDataSource;